import React, { useContext } from 'react';
import { StyledPre } from 'flow/editor/styles';
import RHSTextField from './RHSTextField';
import { useAppDispatch } from '~/store/reduxHooks';
import { updateThreshold } from 'flow/store/redux/thunks/thresholdUpdates';
import { createWorkflowHistoryThunk } from 'flow/store/redux/thunks';
import { Operation } from 'flow/service/changelog/types';
import { createUiEffectContext } from 'flow/service/history';
import { changeDescription } from 'flow/store/redux/types';
import { isPreviewAction } from 'flow/service/actions';
import { ThresholdContext } from '../context';
import { RuleBuilderContext } from '../../../context';
import { UserContext } from '~/dashboard/context';

interface RHSRangeInputProps {
  shouldUseDefaultString: boolean;
}

const RHSRangeInput = ({ shouldUseDefaultString }: RHSRangeInputProps) => {
  const dispatch = useAppDispatch();
  const { featureFlags } = useContext(UserContext);
  const { populatedThreshold } = useContext(ThresholdContext);
  const { sourceAction } = useContext(RuleBuilderContext);

  const { right: { attributeValue } } = populatedThreshold;
  const values = attributeValue != null ? String(attributeValue).split(',') : [''];

  const updateRangeValue = (index: 0 | 1, newValue: string) => {
    const nextValues = [...values];
    nextValues[index] = newValue;

    const stateChange = () => dispatch(
      updateThreshold.rightValue(populatedThreshold.publicId, nextValues.join(',')),
    );

    dispatch(createWorkflowHistoryThunk(
      stateChange,
      Boolean(featureFlags?.workflowEditorUndoRedo) && !isPreviewAction(sourceAction),
      {
        operation: Operation.Modify,
        uiEffectContext: createUiEffectContext(changeDescription.threshold, {
          publicId: populatedThreshold.publicId,
          actionId: populatedThreshold.actionId,
        }),
      },
    ));
  };

  return (
    <>
      <RHSTextField
        onChange={val => updateRangeValue(0, val)}
        shouldUseDefaultString={shouldUseDefaultString}
        value={values[0]}
      />
      <StyledPre>to</StyledPre>
      <RHSTextField
        onChange={val => updateRangeValue(1, val)}
        shouldUseDefaultString={shouldUseDefaultString}
        value={values[1] ?? ''}
      />
    </>
  );
};

export default RHSRangeInput;
